import { isArray, deepCopy } from '@/common/js/utils'
// import Uploader from '../media/uploader'
import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'

export default {
  // components: { Uploader },
  data() {
    return {
      uploadModel: false,
      uploadType: '', // 上传类型
      uploadName: '',
      uploadSmart: 0, // 智能封面视频ID
      uploadWidth: 0,
      uploadHeight: 0,
      uploadSize: 0,
      uploadMult: 1,
      uploadIndex: null,
      uploadBatch: null
    }
  },
  methods: {
    switchToType(val) {
      if (val === 'ELEMENT_TYPE_IMAGE') return 'image'
      else if (val === 'ELEMENT_TYPE_VIDEO') return 'video'
      else if (val === 'ELEMENT_TYPE_COVER') return 'cover'
      else if (val === 'ELEMENT_TYPE_LOGO') return 'logo'
      else throw new Error('未知的素材类型')
    },
    switchType(type) {
      this.uploadType = type
    },
    getElementName(width) {
      let type = ''
      switch (width) {
        case 1280:
          type = 'video'
          break
        case 720:
          type = 'video'
          break
        case 1140:
          type = 'large'
          break
        case 370:
          type = 'image'
          break
        default:
          type = 'image'
          break
      }
      return type
    },
    // 选择素材上传入口
    selectImage(params) {
      const { name, type, width, height, size, batch, mult, index, smart } = params
      const uploadType = this.switchToType(type)
      this.uploadType = uploadType
      this.uploadWidth = width
      this.uploadHeight = height
      this.uploadName = name
      this.uploadSize = size
      this.uploadSmart = smart || 0
      this.uploadIndex = index
      this.uploadBatch = batch
      this.uploadMult = mult || 1
      // this.uploadModel = true

      let assetType = uploadType
      if (assetType === 'cover') {
        this.selectorProps.videoId = smart
        assetType = 'poster'
      }
      // 清空查询参数
      this.selectorProps.form = this.getInitSelectorForm()
      this.selectorProps.form.size = `${width}*${height}`
      this.selectorProps.assetType = MATERIAL_TYPE_ID[assetType]
      this.selectorProps.max = mult || 1
      this.showSelectorModal = true
    },
    onSelectorClose() {},
    // 选择素材回调
    uploadFileHandle(data) {
      if (!isArray(data)) return
      const sourceIds = this.formItem.creativeDetails.map((ret) => ret.photo_id || ret.image_token)
      if (this.uploadType === 'video') {
        // 批量添加视频
        if (this.uploadBatch) {
          data.forEach((ret) => {
            const uploadType = ret.width > 720 ? this.uploadType : 'vertical'
            const creativeElement = deepCopy(this.creativeElements[uploadType])
            const sourceVideo = {
              photo_id: ret.id,
              url: ret.url,
              width: ret.width,
              height: ret.height,
              file_size: ret.size,
              type: this.uploadType
            }
            const sourceImage = {
              image_token: ret.id,
              url: ret.cover_url,
              cover_width: ret.cover_width,
              cover_height: ret.cover_height,
              cover_size: ret.cover_size,
              type: this.uploadType
            }
            const videoIndex = creativeElement.template.findIndex((ret) => ret.element === 'ELEMENT_TYPE_VIDEO')
            const coverIndex = creativeElement.template.findIndex((ret) => ret.element === 'ELEMENT_TYPE_COVER')
            this.$set(creativeElement.template[videoIndex], this.uploadType, ret.id)
            this.$set(creativeElement.template[coverIndex], 'cover', ret.id)
            this.formItem[`${this.uploadType}Creative`].push(creativeElement)
            if (!sourceIds.includes(ret.id)) {
              this.formItem.creativeDetails.push(...[sourceVideo, sourceImage])
            }
          })
        } else if (typeof this.uploadIndex === 'number') {
          // 单个替换
          const item = data.pop()
          const creativeElement = this.formItem[`${this.uploadType}Creative`][this.uploadIndex].template
          const videoIndex = creativeElement.findIndex((ret) => ret.element === 'ELEMENT_TYPE_VIDEO')
          const coverIndex = creativeElement.findIndex((ret) => ret.element === 'ELEMENT_TYPE_COVER')
          const sourceVideo = {
            photo_id: item.id,
            url: item.url,
            width: item.width,
            height: item.height,
            file_size: item.size,
            type: this.uploadType
          }
          const sourceImage = {
            image_token: item.id,
            url: item.cover_url,
            cover_width: item.cover_width,
            cover_height: item.cover_height,
            cover_size: item.cover_size,
            type: this.uploadType
          }
          this.$set(creativeElement[videoIndex], this.uploadType, item.id)
          this.$set(creativeElement[coverIndex], 'cover', item.id)
          if (!sourceIds.includes(item.id)) {
            this.formItem.creativeDetails.push(...[sourceVideo, sourceImage])
          }
        }
      } else if (['cover', 'image'].includes(this.uploadType)) {
        // 三图
        if (['group', 'image1', 'image2', 'image3'].includes(this.uploadName)) {
          if (typeof this.uploadIndex === 'number') {
            const creativeElement = this.formItem.groupCreative[this.uploadIndex].template[0].children
            data.forEach((ret, i) => {
              const sourceImage = {
                image_token: ret.id,
                url: ret.url,
                width: ret.width,
                height: ret.height,
                file_size: ret.size,
                type: this.uploadType
              }
              this.$set(creativeElement[i], `${this.uploadType}${i + 1}`, ret.id)
              if (!sourceIds.includes(ret.id)) {
                this.formItem.creativeDetails.push(sourceImage)
              }
            })
          } else {
            const creativeElement = deepCopy(this.creativeElements.group)
            data.forEach((ret, i) => {
              const sourceImage = {
                image_token: ret.id,
                url: ret.url,
                width: ret.width,
                height: ret.height,
                file_size: ret.size,
                type: this.uploadType
              }
              this.$set(creativeElement.template[0].children[i], `${this.uploadType}${i + 1}`, ret.id)
              if (!sourceIds.includes(ret.id)) {
                this.formItem.creativeDetails.push(sourceImage)
              }
            })
            this.formItem.groupCreative.push(creativeElement)
          }
        } else if (this.uploadBatch) {
          // 批量添加封面
          data.forEach((ret) => {
            const uploadType = this.getElementName(ret.width)
            const creativeElement = deepCopy(this.creativeElements[uploadType])
            const sourceImage = {
              image_token: ret.id,
              url: ret.url,
              width: ret.width,
              height: ret.height,
              file_size: ret.size,
              type: this.uploadType
            }
            const imageIndex = creativeElement.template.findIndex((ret) => ret.element === `ELEMENT_TYPE_${this.uploadType.toUpperCase()}`)
            this.$set(creativeElement.template[imageIndex], this.uploadType, ret.id)
            this.formItem[`${uploadType}Creative`].push(creativeElement)
            if (!sourceIds.includes(ret.id)) {
              this.formItem.creativeDetails.push(sourceImage)
            }
          })
        } else if (typeof this.uploadIndex === 'number') {
          const item = data.pop()
          const uploadType = this.getElementName(item.width)
          const creativeElement = this.formItem[`${uploadType}Creative`][this.uploadIndex].template
          const sourceImage = {
            image_token: item.id,
            url: item.url,
            width: item.width,
            height: item.height,
            file_size: item.size,
            type: this.uploadType
          }
          const imageIndex = creativeElement.findIndex((ret) => ret.element === `ELEMENT_TYPE_${this.uploadType.toUpperCase()}`)
          if (imageIndex > -1) this.$set(creativeElement[imageIndex], this.uploadType, item.id)
          else if (uploadType === 'video') this.$set(creativeElement[1], 'cover', item.id)
          if (!sourceIds.includes(item.id)) {
            this.formItem.creativeDetails.push(sourceImage)
          }
        }
      } else if (['logo'].includes(this.uploadType)) {
        const item = data.pop()
        const sourceImage = {
          id: item.id,
          url: item.url,
          width: item.width,
          height: item.height,
          file_size: item.size,
          type: this.uploadType
        }
        this.$set(this.formItem, 'userPortrait', item.id)
        this.formItem.creativeDetails.push(sourceImage)
      }
      this.uploadModel = false
    },
    // 上传完回显
    uploadFileComplet({ file, element }) {
      const index = this.tempalteJson.findIndex((ret) => ret.element === element)
      if (element === 'ELEMENT_TYPE_VIDEO' && index > -1 && file.photo_id) {
        this.tempalteJson[index].video = file.photo_id
        this.source.push(file)
      } else if (element === 'ELEMENT_TYPE_COVER' && index > -1 && file.image_token) {
        this.tempalteJson[index].cover = file.image_token
        this.source.push(file)
      } else if (index > -1 && file.image_token) {
        this.tempalteJson[index].image = file.image_token
        this.source.push(file)
      }
    }
  }
}
